interface LoadingSkeletonProps {
  type: 'services' | 'caseStudies' | 'process';
}

export const LoadingSkeleton = ({ type }: LoadingSkeletonProps) => {
  if (type === 'services') {
    return (
      <section className="py-24 bg-brand-dark">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header skeleton */}
          <div className="text-center mb-16 animate-pulse">
            <div className="h-12 bg-brand-base/50 rounded-lg w-96 mx-auto mb-6" />
            <div className="h-6 bg-brand-base/30 rounded-lg w-full max-w-2xl mx-auto" />
          </div>

          {/* Cards skeleton */}
          <div className="grid md:grid-cols-3 gap-8">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="p-8 rounded-2xl bg-brand-base/50 border border-brand-border animate-pulse"
              >
                <div className="w-14 h-14 bg-brand-primary/10 rounded-xl mb-6" />
                <div className="h-8 bg-brand-base/30 rounded-lg w-3/4 mb-4" />
                <div className="space-y-2 mb-6">
                  <div className="h-4 bg-brand-base/20 rounded w-full" />
                  <div className="h-4 bg-brand-base/20 rounded w-5/6" />
                </div>
                <div className="space-y-3 mb-8">
                  <div className="h-4 bg-brand-base/20 rounded w-2/3" />
                  <div className="h-4 bg-brand-base/20 rounded w-3/4" />
                  <div className="h-4 bg-brand-base/20 rounded w-1/2" />
                </div>
                <div className="h-12 bg-brand-base/20 rounded-lg w-full" />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (type === 'caseStudies') {
    return (
      <section className="py-24 bg-brand-base border-y border-brand-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header skeleton */}
          <div className="text-center mb-16 animate-pulse">
            <div className="h-12 bg-brand-dark/50 rounded-lg w-96 mx-auto mb-6" />
            <div className="h-6 bg-brand-dark/30 rounded-lg w-full max-w-2xl mx-auto" />
          </div>

          {/* Cards skeleton */}
          <div className="grid md:grid-cols-3 gap-8">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="bg-brand-dark rounded-2xl p-8 border border-brand-border animate-pulse"
              >
                <div className="flex space-x-1 mb-6">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <div key={star} className="w-4 h-4 bg-brand-secondary/20 rounded" />
                  ))}
                </div>
                <div className="h-6 bg-brand-base/30 rounded w-2/3 mb-2" />
                <div className="h-10 bg-brand-primary/20 rounded w-32 mb-4" />
                <div className="space-y-2">
                  <div className="h-4 bg-brand-base/20 rounded w-full" />
                  <div className="h-4 bg-brand-base/20 rounded w-5/6" />
                  <div className="h-4 bg-brand-base/20 rounded w-4/5" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return null;
};
